<template>
    <tr
        :class="{ 'selected-row': (selectedItem.id == row.id && selectedItem.type == row.type) }"
        class="table-row-draggable"
        @click="selectItem(row)"
        @dragstart="startDrag($event, row)"
        @drop="onDrop($event, row)"
        @dragover.prevent
        @dragenter.prevent
        draggable="true"
    >
        <td>
            <div class="form-check">
                <input class="form-check-input"
                    type="checkbox"
                    value=""
                    :checked="isSelected(row)"
                    @change="updateSelectedRows({ event: $event, selectedRow: row })">
            </div>
        </td>

        <td>
            <div class="row" :style="{ marginLeft: deep*25 + 'px' }">
                <div class="d-flex col-lg-1 col-md-1 col-sm-1 col-xl-1 col-xxl-1 align-items-center">
                    <div v-if="row.openned != true && row.type == 2" v-on:click="openDir(row)" @click="toggleDirState(row)">
                        <svg style="flex-shrink: 0;" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L9 7.8L1 14.6" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>

                    <div v-else-if="row.type == 2" v-on:click="closeDir(row)" @click="toggleDirState(row)">
                        <svg style="flex-shrink: 0;" width="16" height="10" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.7998 1.7998L7.9998 9.7998L1.1998 1.7998" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div :class="{ 'pe-2': row.type != 2 }" class="d-flex col align-items-center">
                    <svg v-if="row.type == 2" style="flex-shrink: 0;" class="pe-2" width="23" height="20" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.28 2.44146H9.2025L6.56325 0.0469512C6.52967 0.0171324 6.4855 0.000374109 6.4395 0H0.72C0.32175 0 0 0.305183 0 0.682927V13.3171C0 13.6948 0.32175 14 0.72 14H17.28C17.6783 14 18 13.6948 18 13.3171V3.12439C18 2.74665 17.6783 2.44146 17.28 2.44146Z" fill="#A8A8A8"/>
                    </svg>
                    <svg v-else class="pe-2" style="flex-shrink: 0;" width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 2.85714C0 2.09938 0.302901 1.37266 0.842068 0.836838C1.38124 0.30102 2.1125 0 2.875 0H20.125C20.8875 0 21.6188 0.30102 22.1579 0.836838C22.6971 1.37266 23 2.09938 23 2.85714V17.1429C23 17.9006 22.6971 18.6273 22.1579 19.1632C21.6188 19.699 20.8875 20 20.125 20H2.875C2.1125 20 1.38124 19.699 0.842068 19.1632C0.302901 18.6273 0 17.9006 0 17.1429V2.85714ZM1.4375 15.7143V17.1429C1.4375 17.5217 1.58895 17.8851 1.85853 18.153C2.12812 18.4209 2.49375 18.5714 2.875 18.5714H20.125C20.5062 18.5714 20.8719 18.4209 21.1415 18.153C21.411 17.8851 21.5625 17.5217 21.5625 17.1429V12.1429L16.1331 9.36143C15.9983 9.29432 15.8456 9.27104 15.6968 9.29488C15.5479 9.31872 15.4104 9.38848 15.3036 9.49429L9.9705 14.7943L6.14675 12.2629C6.00869 12.1715 5.8431 12.1304 5.67804 12.1466C5.51298 12.1627 5.35862 12.2351 5.24113 12.3514L1.4375 15.7143ZM8.625 6.42857C8.625 5.86025 8.39782 5.31521 7.99345 4.91334C7.58907 4.51148 7.04062 4.28571 6.46875 4.28571C5.89688 4.28571 5.34843 4.51148 4.94405 4.91334C4.53968 5.31521 4.3125 5.86025 4.3125 6.42857C4.3125 6.99689 4.53968 7.54194 4.94405 7.9438C5.34843 8.34566 5.89688 8.57143 6.46875 8.57143C7.04062 8.57143 7.58907 8.34566 7.99345 7.9438C8.39782 7.54194 8.625 6.99689 8.625 6.42857Z" fill="#A8A8A8"/>
                    </svg>
                    {{ row.type == 2 ? computedTitle : computedName }}
                </div>
            </div>
        </td>

        <td>
            {{ row.brand }}
        </td>

        <td>
            {{ dateFormat(row.created_at) }}
        </td>

        <td>
            {{ dateFormat(row.updated_at) }}
        </td>

        <td>
            {{ row.user }}
        </td>

        <td class="align-bottom">
            <div class="d-flex">
                <button @click.prevent.stop="setItemToUpdate(row)" class="table-action table-action_edit m-auto" title="Редактировать"></button>
            </div>
        </td>
    </tr>

    <template v-if="row.openned == true" v-for="item in row.content">
        <content-table-row-component
            @dragAction="startDrag"
            @dragDropAction="onDrop"
            @openDir="openDir"
            :row="item"
            :deep="this.deep + 1">
        </content-table-row-component>
    </template>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContentTableRowComponent",

    props: {
        row: Object,
        deep: Number,
    },

    data: function () {
        return {
            del_options_show: false,
            modalRemove: false
        }
    },

    computed: {
        ...mapState('content', ['selectedItem', 'selectedRows']),

        computedTitle() {
            return this.row.title.replace(/(.{8})/g, '$1\u200b');
        },

        computedName() {
            return this.row.name.replace(/(.{8})/g, '$1\u200b');
        }
    },

    emits: [
        'dragAction',
        'dragDropAction',
        'openDir',
    ],

    watch: {
        row: {
            handler(newVal) {
                if (newVal) {
                    this.setDirState();
                }
            },
        }
    },

    methods: {
        ...mapMutations('content', ['selectItem', 'deselectItem', 'setItemToRemove', 'setItemToUpdate', 'updateSelectedRows']),
        ...mapActions('content', ['loadItems', 'deleteFolder', 'deleteContent']),

        delClick: function (item) {
            if(item.type == 2) this.modalRemove = !this.modalRemove;
            else {
                let confirmation = confirm('Вы уверены что хотите удалить контент?');
                if(!confirmation) return;
                this.setItemToRemove({ item, removeContent: false });
                this.deleteContent();
                this.loadItems();
            }
        },

        delItem: function (item, content = false) {
            this.setItemToRemove({ item, removeContent: content });
            this.deleteFolder();
            this.loadItems();
            this.modalRemove = false;
        },

        startDrag: function (event, item) {
            this.deselectItem();
            this.$emit('dragAction', event, item);
        },

        onDrop: function (event, group) {
            this.$emit('dragDropAction', event, group);
        },

        async openDir(item) {
            let result = await this.$emit('openDir', item);
            item.openned = true;
        },

        closeDir: function (item) {
            item.openned = false;
        },

        dateFormat: (date, displayTime = false) => {
            if(typeof date === 'string')
            {
                return date.replace(/(\d{4})-(\d{2})-(\d{2})(?:\s|T)([\d\:]+).*/, '$3.$2.$1' + (displayTime ? ' $4' : ''));
            }
            return '';
        },

        toggleDirState: function() {
            if(!localStorage.getItem(`dir${this.row.id}`)) {
                localStorage.setItem(`dir${this.row.id}`, true);
            } else {
                localStorage.removeItem(`dir${this.row.id}`);
            }
        },

        setDirState () {
            if(localStorage.getItem(`dir${this.row.id}`)) {
                this.openDir(this.row);
            }
        },
        isSelected(row) {
            return this.selectedRows.some(elem => elem.id === row.id)
        }
    },
    mounted() {
        this.setDirState();
    }
}
</script>

<style scoped>
.del-options {
    position: sticky;
    overflow: auto;
    background-color: white;
    border-radius: 8px;
    border-color: #1a202c;
    border-style: solid;
    border-width: 1px;
}
.del-options-item {
    width: 200px;
    padding: 5px;
}
.del-options-item:hover {
    background-color: #0dcaf0;
}
.selected-row {
    background-color: #F1F7FF;
    transition: 0.1s;
}
.row {
    flex-wrap: nowrap;
}
</style>
